/**
 * ResizeObserver callback that defers work to the next animation frame.
 * Avoids "ResizeObserver loop completed with undelivered notifications" when
 * resize handlers mutate layout (e.g. lightweight-charts applyOptions).
 */
export function observeElementResize(element, callback) {
  let rafId = null;

  const observer = new ResizeObserver(() => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(() => {
      rafId = null;
      callback();
    });
  });

  observer.observe(element);

  return () => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
    observer.disconnect();
  };
}
